import { render, staticRenderFns } from "./TableHeaderCellV2.vue?vue&type=template&id=6448a188&scoped=true&"
import script from "./TableHeaderCellV2.vue?vue&type=script&lang=js&"
export * from "./TableHeaderCellV2.vue?vue&type=script&lang=js&"
import style0 from "./TableHeaderCellV2.vue?vue&type=style&index=0&id=6448a188&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6448a188",
  null
  
)

export default component.exports